import { useState } from "react";
import { useUser } from "../../context/userContext";
import axios from "axios";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_icon.svg";

function PasswordModal({ initials, handlePasswordClose }) {
  const { userData } = useUser();
  const [isContentLoading, setIsContentLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const handleUpdatePassword = async () => {
    // Perform validation
    if (!currentPassword || !newPassword || !confirmNewPassword) {
      alert("All fields are required.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      alert("New password and confirm password do not match.");
      setNewPassword("");
      setConfirmNewPassword("");
      return;
    }

    try {

      setIsContentLoading(true);

      // Perform password validation
      const validationResponse = await axios.post(
        "https://soliboat.solidaridadasia.com/password_validation",
        {
          mobile_number: userData.mobile_number,
          password: currentPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          withCredentials: true,
        }
      );

      // Check validation response
      if (validationResponse.data.success) {
        // Password is valid, proceed with updating password
        const updateResponse = await axios.post(
          "https://soliboat.solidaridadasia.com/update_password",
          {
            mobile_number: userData.mobile_number,
            password: newPassword,
          }
        );

        console.log(updateResponse);

        // Check update response
        if (updateResponse.data.success) {
          alert("Password updated successfully.");
        } else {
          alert("Failed to update password. Please try again.");
        }
      } else {
        alert("Invalid current password. Please try again.");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setNewPassword("");
      setConfirmNewPassword("");
      setCurrentPassword("");
      handlePasswordClose();
      setIsContentLoading(false);
    }
  };

  const handleInputChange = (e, setter) => {
    setter(e.target.value);
  };

  return (
    <>
      {/* Loading screen while API calls are in progress */}
      {isContentLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-50 z-[100]">
          <div className="w-20 h-20 animate-spin">
            <div className="h-full w-full border-4 border-t-dark/50 border-b-dark/80 rounded-[50%]" />
          </div>
          <div className="text-center text-sm lg:text-xl font-medium text-gray-500 mt-8 mx-8 lg:mx-0">
            Please wait while while we process your request{" "}
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
          </div>
        </div>
      )}
      <div className="fixed inset-0 flex items-center justify-center drop-shadow-[0_4px_24px_rgba(0,0,0,0.24)] z-50">
        <div className="fixed inset-0 bg-black opacity-50" />

        <div className="relative w-[90%] lg:w-3/4 xl:w-1/2 bg-white p-[2px] rounded-xl">
          <div className="flex flex-col justify-center items-center w-full mb-6 bg-gradient-to-b from-blue-400/30 rounded-t-xl">
            <div
              className="absolute top-3 right-3 flex rounded-full cursor-pointer hover:scale-[105%]"
              onClick={handlePasswordClose}
            >
              <CloseIcon className="w-8 h-8" />
            </div>

            <span className="flex items-center justify-center w-20 h-20 mt-8 text-black text-3xl border-4 border-white/80    rounded-full bg-neutral-100">
              {initials}
            </span>
            <p className="mt-4 text-gray-900 text-2xl font-semibold">
              Change Password
            </p>
            <p className="mt-1 mx-2 text-center text-sm md:text-base text-gray-400 font-medium">
              Update your profile password to keep you data secure!
            </p>
          </div>

          <div className="mt-3 border border-neutral-100" />

          <div className="mt-4 mb-4 md:mb-6 mx-4 md:mx-7">
            <h1 className="mb-2 text-lg font-semibold text-gray-900">
              Current Password:
            </h1>

            <input
              type="password"
              name="currentPassword"
              value={currentPassword}
              placeholder="Enter your current password"
              className="w-full rounded-md py-2 px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
              onChange={(e) => handleInputChange(e, setCurrentPassword)}
            />
            <div className="mt-3 border border-neutral-100" />
            <h1 className="my-3 text-lg font-semibold text-gray-900">
              Set New Password:
            </h1>

            <div>
              <label
                htmlFor="newPassword"
                className="mb-1 block font-medium text-slate-500 dark:text-white"
              >
                Password
              </label>
              <input
                type="password"
                name="newPassword"
                value={newPassword}
                placeholder="Enter new password"
                className="w-full rounded-md py-2 px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                onChange={(e) => handleInputChange(e, setNewPassword)}
              />

              <label
                htmlFor="newPassword"
                className="mt-3 mb-1 block font-medium text-slate-500 dark:text-white"
              >
                Confirm Password
              </label>
              <input
                type="password"
                name="confirmCurrentPassword"
                value={confirmNewPassword}
                placeholder="Confirm new password"
                className="w-full rounded-md py-2 px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                onChange={(e) => handleInputChange(e, setConfirmNewPassword)}
              />
            </div>

            <div className="flex justify-end items-center pt-4">
              <button
                className="bg-primary text-white px-2 py-2 rounded-md"
                onClick={handleUpdatePassword}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PasswordModal;
